import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getEnvelopeEndpointWithUrlEncodedAuth } from './api.js';
import { DEFAULT_ENVIRONMENT } from './constants.js';
import { getTraceContextFromScope, getCurrentScope, getIsolationScope, withScope } from './currentScopes.js';
import { DEBUG_BUILD } from './debug-build.js';
import { createEventEnvelope, createSessionEnvelope } from './envelope.js';
import { setupIntegration, afterSetupIntegrations, setupIntegrations } from './integration.js';
import { updateSession } from './session.js';
import { getDynamicSamplingContextFromScope, getDynamicSamplingContextFromSpan } from './tracing/dynamicSamplingContext.js';
import { createClientReportEnvelope } from './utils/clientreport.js';
import { debug } from './utils/debug-logger.js';
import { makeDsn, dsnToString } from './utils/dsn.js';
import { addItemToEnvelope, createAttachmentEnvelopeItem } from './utils/envelope.js';
import { getPossibleEventMessages } from './utils/eventUtils.js';
import { isPrimitive, isParameterizedString, isThenable, isPlainObject } from './utils/is.js';
import { merge } from './utils/merge.js';
import { uuid4, checkOrSetAlreadyCaught } from './utils/misc.js';
import { parseSampleRate } from './utils/parseSampleRate.js';
import { prepareEvent } from './utils/prepareEvent.js';
import { shouldIgnoreSpan, reparentChildSpans } from './utils/should-ignore-span.js';
import { showSpanDropWarning, getActiveSpan, spanToTraceContext } from './utils/spanUtils.js';
import { rejectedSyncPromise } from './utils/syncpromise.js';
import { convertTransactionEventToSpanJson, convertSpanJsonToTransactionEvent } from './utils/transactionEvent.js';

/* eslint-disable max-lines */

var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
var MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
var INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
var DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function _makeInternalError(message) {
  return _defineProperty({
    message: message
  }, INTERNAL_ERROR_SYMBOL, true);
}
function _makeDoNotSendEventError(message) {
  return _defineProperty({
    message: message
  }, DO_NOT_SEND_EVENT_SYMBOL, true);
}
function _isInternalError(error) {
  return !!error && typeof error === 'object' && INTERNAL_ERROR_SYMBOL in error;
}
function _isDoNotSendEventError(error) {
  return !!error && typeof error === 'object' && DO_NOT_SEND_EVENT_SYMBOL in error;
}

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
var Client = /*#__PURE__*/function () {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  function Client(options) {
    _classCallCheck(this, Client);
    this._options = options;
    this._integrations = {};
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];
    if (options.dsn) {
      this._dsn = makeDsn(options.dsn);
    } else {
      DEBUG_BUILD && debug.warn('No DSN provided, client will not send events.');
    }
    if (this._dsn) {
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
      this._transport = options.transport(_objectSpread(_objectSpread({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this)
      }, options.transportOptions), {}, {
        url: url
      }));
    }
  }

  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  return _createClass(Client, [{
    key: "captureException",
    value: function captureException(exception, hint, scope) {
      var _this = this;
      var eventId = uuid4();

      // ensure we haven't captured this very object before
      if (checkOrSetAlreadyCaught(exception)) {
        DEBUG_BUILD && debug.log(ALREADY_SEEN_ERROR);
        return eventId;
      }
      var hintWithEventId = _objectSpread({
        event_id: eventId
      }, hint);
      this._process(this.eventFromException(exception, hintWithEventId).then(function (event) {
        return _this._captureEvent(event, hintWithEventId, scope);
      }));
      return hintWithEventId.event_id;
    }

    /**
     * Captures a message event and sends it to Sentry.
     *
     * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
     */
  }, {
    key: "captureMessage",
    value: function captureMessage(message, level, hint, currentScope) {
      var _this2 = this;
      var hintWithEventId = _objectSpread({
        event_id: uuid4()
      }, hint);
      var eventMessage = isParameterizedString(message) ? message : String(message);
      var promisedEvent = isPrimitive(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
      this._process(promisedEvent.then(function (event) {
        return _this2._captureEvent(event, hintWithEventId, currentScope);
      }));
      return hintWithEventId.event_id;
    }

    /**
     * Captures a manually created event and sends it to Sentry.
     *
     * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
     */
  }, {
    key: "captureEvent",
    value: function captureEvent(event, hint, currentScope) {
      var eventId = uuid4();

      // ensure we haven't captured this very object before
      if (hint !== null && hint !== void 0 && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
        DEBUG_BUILD && debug.log(ALREADY_SEEN_ERROR);
        return eventId;
      }
      var hintWithEventId = _objectSpread({
        event_id: eventId
      }, hint);
      var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
      var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
      var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
      this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
      return hintWithEventId.event_id;
    }

    /**
     * Captures a session.
     */
  }, {
    key: "captureSession",
    value: function captureSession(session) {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      updateSession(session, {
        init: false
      });
    }

    /**
     * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
     *
     * @param checkIn An object that describes a check in.
     * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
     * to create a monitor automatically when sending a check in.
     * @param scope An optional scope containing event metadata.
     * @returns A string representing the id of the check in.
     */

    /**
     * Get the current Dsn.
     */
  }, {
    key: "getDsn",
    value: function getDsn() {
      return this._dsn;
    }

    /**
     * Get the current options.
     */
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this._options;
    }

    /**
     * Get the SDK metadata.
     * @see SdkMetadata
     */
  }, {
    key: "getSdkMetadata",
    value: function getSdkMetadata() {
      return this._options._metadata;
    }

    /**
     * Returns the transport that is used by the client.
     * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
     */
  }, {
    key: "getTransport",
    value: function getTransport() {
      return this._transport;
    }

    /**
     * Wait for all events to be sent or the timeout to expire, whichever comes first.
     *
     * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
     *   cause the client to wait until all events are sent before resolving the promise.
     * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
     * still events in the queue when the timeout is reached.
     */
    // @ts-expect-error - PromiseLike is a subset of Promise
  }, {
    key: "flush",
    value: (function () {
      var _flush = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(timeout) {
        var transport, clientFinished, transportFlushed;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              transport = this._transport;
              if (transport) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", true);
            case 3:
              this.emit('flush');
              _context.next = 6;
              return this._isClientDoneProcessing(timeout);
            case 6:
              clientFinished = _context.sent;
              _context.next = 9;
              return transport.flush(timeout);
            case 9:
              transportFlushed = _context.sent;
              return _context.abrupt("return", clientFinished && transportFlushed);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function flush(_x) {
        return _flush.apply(this, arguments);
      }
      return flush;
    }()
    /**
     * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
     *
     * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
     *   the client to wait until all events are sent before disabling itself.
     * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
     * it doesn't.
     */
    // @ts-expect-error - PromiseLike is a subset of Promise
    )
  }, {
    key: "close",
    value: (function () {
      var _close = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(timeout) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.flush(timeout);
            case 2:
              result = _context2.sent;
              this.getOptions().enabled = false;
              this.emit('close');
              return _context2.abrupt("return", result);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function close(_x2) {
        return _close.apply(this, arguments);
      }
      return close;
    }()
    /**
     * Get all installed event processors.
     */
    )
  }, {
    key: "getEventProcessors",
    value: function getEventProcessors() {
      return this._eventProcessors;
    }

    /**
     * Adds an event processor that applies to any event processed by this client.
     */
  }, {
    key: "addEventProcessor",
    value: function addEventProcessor(eventProcessor) {
      this._eventProcessors.push(eventProcessor);
    }

    /**
     * Initialize this client.
     * Call this after the client was set on a scope.
     */
  }, {
    key: "init",
    value: function init() {
      if (this._isEnabled() ||
      // Force integrations to be setup even if no DSN was set when we have
      // Spotlight enabled. This is particularly important for browser as we
      // don't support the `spotlight` option there and rely on the users
      // adding the `spotlightBrowserIntegration()` to their integrations which
      // wouldn't get initialized with the check below when there's no DSN set.
      this._options.integrations.some(function (_ref3) {
        var name = _ref3.name;
        return name.startsWith('Spotlight');
      })) {
        this._setupIntegrations();
      }
    }

    /**
     * Gets an installed integration by its name.
     *
     * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
     */
  }, {
    key: "getIntegrationByName",
    value: function getIntegrationByName(integrationName) {
      return this._integrations[integrationName];
    }

    /**
     * Add an integration to the client.
     * This can be used to e.g. lazy load integrations.
     * In most cases, this should not be necessary,
     * and you're better off just passing the integrations via `integrations: []` at initialization time.
     * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
     */
  }, {
    key: "addIntegration",
    value: function addIntegration(integration) {
      var isAlreadyInstalled = this._integrations[integration.name];

      // This hook takes care of only installing if not already installed
      setupIntegration(this, integration, this._integrations);
      // Here we need to check manually to make sure to not run this multiple times
      if (!isAlreadyInstalled) {
        afterSetupIntegrations(this, [integration]);
      }
    }

    /**
     * Send a fully prepared event to Sentry.
     */
  }, {
    key: "sendEvent",
    value: function sendEvent(event) {
      var _this3 = this;
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.emit('beforeSendEvent', event, hint);
      var env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
      var _iterator = _createForOfIteratorHelper(hint.attachments || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attachment = _step.value;
          env = addItemToEnvelope(env, createAttachmentEnvelopeItem(attachment));
        }

        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.sendEnvelope(env).then(function (sendResponse) {
        return _this3.emit('afterSendEvent', event, sendResponse);
      });
    }

    /**
     * Send a session or session aggregrates to Sentry.
     */
  }, {
    key: "sendSession",
    value: function sendSession(session) {
      // Backfill release and environment on session
      var _this$_options = this._options,
        clientReleaseOption = _this$_options.release,
        _this$_options$enviro = _this$_options.environment,
        clientEnvironmentOption = _this$_options$enviro === void 0 ? DEFAULT_ENVIRONMENT : _this$_options$enviro;
      if ('aggregates' in session) {
        var sessionAttrs = session.attrs || {};
        if (!sessionAttrs.release && !clientReleaseOption) {
          DEBUG_BUILD && debug.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
          return;
        }
        sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
        sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
        session.attrs = sessionAttrs;
      } else {
        if (!session.release && !clientReleaseOption) {
          DEBUG_BUILD && debug.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
          return;
        }
        session.release = session.release || clientReleaseOption;
        session.environment = session.environment || clientEnvironmentOption;
      }
      this.emit('beforeSendSession', session);
      var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);

      // sendEnvelope should not throw
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.sendEnvelope(env);
    }

    /**
     * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
     */
  }, {
    key: "recordDroppedEvent",
    value: function recordDroppedEvent(reason, category) {
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      if (this._options.sendClientReports) {
        // We want to track each category (error, transaction, session, replay_event) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        // With typescript 4.1 we could even use template literal types
        var key = "".concat(reason, ":").concat(category);
        DEBUG_BUILD && debug.log("Recording outcome: \"".concat(key, "\"").concat(count > 1 ? " (".concat(count, " times)") : ''));
        this._outcomes[key] = (this._outcomes[key] || 0) + count;
      }
    }

    /* eslint-disable @typescript-eslint/unified-signatures */
    /**
     * Register a callback for whenever a span is started.
     * Receives the span as argument.
     * @returns {() => void} A function that, when executed, removes the registered callback.
     */

    /**
     * Register a hook on this client.
     */
  }, {
    key: "on",
    value: function on(hook, callback) {
      var hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();

      // Wrap the callback in a function so that registering the same callback instance multiple
      // times results in the callback being called multiple times.
      // @ts-expect-error - The `callback` type is correct and must be a function due to the
      // individual, specific overloads of this function.
      // eslint-disable-next-line @typescript-eslint/ban-types
      var uniqueCallback = function uniqueCallback() {
        return callback.apply(void 0, arguments);
      };
      hookCallbacks.add(uniqueCallback);

      // This function returns a callback execution handler that, when invoked,
      // deregisters a callback. This is crucial for managing instances where callbacks
      // need to be unregistered to prevent self-referencing in callback closures,
      // ensuring proper garbage collection.
      return function () {
        hookCallbacks.delete(uniqueCallback);
      };
    }

    /** Fire a hook whenever a span starts. */

    /**
     * Emit a hook that was previously registered via `on()`.
     */
  }, {
    key: "emit",
    value: function emit(hook) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      var callbacks = this._hooks[hook];
      if (callbacks) {
        callbacks.forEach(function (callback) {
          return callback.apply(void 0, rest);
        });
      }
    }

    /**
     * Send an envelope to Sentry.
     */
    // @ts-expect-error - PromiseLike is a subset of Promise
  }, {
    key: "sendEnvelope",
    value: (function () {
      var _sendEnvelope = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(envelope) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.emit('beforeEnvelope', envelope);
              if (!(this._isEnabled() && this._transport)) {
                _context3.next = 12;
                break;
              }
              _context3.prev = 2;
              _context3.next = 5;
              return this._transport.send(envelope);
            case 5:
              return _context3.abrupt("return", _context3.sent);
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](2);
              DEBUG_BUILD && debug.error('Error while sending envelope:', _context3.t0);
              return _context3.abrupt("return", {});
            case 12:
              DEBUG_BUILD && debug.error('Transport disabled');
              return _context3.abrupt("return", {});
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 8]]);
      }));
      function sendEnvelope(_x3) {
        return _sendEnvelope.apply(this, arguments);
      }
      return sendEnvelope;
    }()
    /* eslint-enable @typescript-eslint/unified-signatures */
    /** Setup integrations for this client. */
    )
  }, {
    key: "_setupIntegrations",
    value: function _setupIntegrations() {
      var integrations = this._options.integrations;
      this._integrations = setupIntegrations(this, integrations);
      afterSetupIntegrations(this, integrations);
    }

    /** Updates existing session based on the provided event */
  }, {
    key: "_updateSessionFromEvent",
    value: function _updateSessionFromEvent(session, event) {
      var _event$exception;
      var crashed = event.level === 'fatal';
      var errored = false;
      var exceptions = (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values;
      if (exceptions) {
        errored = true;
        var _iterator2 = _createForOfIteratorHelper(exceptions),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ex = _step2.value;
            var mechanism = ex.mechanism;
            if ((mechanism === null || mechanism === void 0 ? void 0 : mechanism.handled) === false) {
              crashed = true;
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      // A session is updated and that session update is sent in only one of the two following scenarios:
      // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
      // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
      var sessionNonTerminal = session.status === 'ok';
      var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
      if (shouldUpdateAndSend) {
        updateSession(session, _objectSpread(_objectSpread({}, crashed && {
          status: 'crashed'
        }), {}, {
          errors: session.errors || Number(errored || crashed)
        }));
        this.captureSession(session);
      }
    }

    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
  }, {
    key: "_isClientDoneProcessing",
    value: (function () {
      var _isClientDoneProcessing2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(timeout) {
        var ticked;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              ticked = 0; // if no timeout is provided, we wait "forever" until everything is processed
            case 1:
              if (!(!timeout || ticked < timeout)) {
                _context4.next = 9;
                break;
              }
              _context4.next = 4;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1);
              });
            case 4:
              if (this._numProcessing) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", true);
            case 6:
              ticked++;
              _context4.next = 1;
              break;
            case 9:
              return _context4.abrupt("return", false);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function _isClientDoneProcessing(_x4) {
        return _isClientDoneProcessing2.apply(this, arguments);
      }
      return _isClientDoneProcessing;
    }() /** Determines whether this SDK is enabled and a transport is present. */)
  }, {
    key: "_isEnabled",
    value: function _isEnabled() {
      return this.getOptions().enabled !== false && this._transport !== undefined;
    }

    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param currentScope A scope containing event metadata.
     * @returns A new event with more information.
     */
  }, {
    key: "_prepareEvent",
    value: function _prepareEvent(event, hint, currentScope, isolationScope) {
      var _this4 = this;
      var options = this.getOptions();
      var integrations = Object.keys(this._integrations);
      if (!hint.integrations && integrations !== null && integrations !== void 0 && integrations.length) {
        hint.integrations = integrations;
      }
      this.emit('preprocessEvent', event, hint);
      if (!event.type) {
        isolationScope.setLastEventId(event.event_id || hint.event_id);
      }
      return prepareEvent(options, event, hint, currentScope, this, isolationScope).then(function (evt) {
        if (evt === null) {
          return evt;
        }
        _this4.emit('postprocessEvent', evt, hint);
        evt.contexts = _objectSpread({
          trace: getTraceContextFromScope(currentScope)
        }, evt.contexts);
        var dynamicSamplingContext = getDynamicSamplingContextFromScope(_this4, currentScope);
        evt.sdkProcessingMetadata = _objectSpread({
          dynamicSamplingContext: dynamicSamplingContext
        }, evt.sdkProcessingMetadata);
        return evt;
      });
    }

    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
  }, {
    key: "_captureEvent",
    value: function _captureEvent(event) {
      var hint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var currentScope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getCurrentScope();
      var isolationScope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getIsolationScope();
      if (DEBUG_BUILD && isErrorEvent(event)) {
        debug.log("Captured error event `".concat(getPossibleEventMessages(event)[0] || '<unknown>', "`"));
      }
      return this._processEvent(event, hint, currentScope, isolationScope).then(function (finalEvent) {
        return finalEvent.event_id;
      }, function (reason) {
        if (DEBUG_BUILD) {
          if (_isDoNotSendEventError(reason)) {
            debug.log(reason.message);
          } else if (_isInternalError(reason)) {
            debug.warn(reason.message);
          } else {
            debug.warn(reason);
          }
        }
        return undefined;
      });
    }

    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param currentScope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
  }, {
    key: "_processEvent",
    value: function _processEvent(event, hint, currentScope, isolationScope) {
      var _this5 = this;
      var options = this.getOptions();
      var sampleRate = options.sampleRate;
      var isTransaction = isTransactionEvent(event);
      var isError = isErrorEvent(event);
      var eventType = event.type || 'error';
      var beforeSendLabel = "before send for type `".concat(eventType, "`");

      // 1.0 === 100% events are sent
      // 0.0 === 0% events are sent
      // Sampling for transaction happens somewhere else
      var parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : parseSampleRate(sampleRate);
      if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
        this.recordDroppedEvent('sample_rate', 'error');
        return rejectedSyncPromise(_makeDoNotSendEventError("Discarding event because it's not included in the random sample (sampling rate = ".concat(sampleRate, ")")));
      }
      var dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
      return this._prepareEvent(event, hint, currentScope, isolationScope).then(function (prepared) {
        if (prepared === null) {
          _this5.recordDroppedEvent('event_processor', dataCategory);
          throw _makeDoNotSendEventError('An event processor returned `null`, will not send event.');
        }
        var isInternalException = hint.data && hint.data.__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }
        var result = processBeforeSend(_this5, options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      }).then(function (processedEvent) {
        if (processedEvent === null) {
          _this5.recordDroppedEvent('before_send', dataCategory);
          if (isTransaction) {
            var spans = event.spans || [];
            // the transaction itself counts as one span, plus all the child spans that are added
            var spanCount = 1 + spans.length;
            _this5.recordDroppedEvent('before_send', 'span', spanCount);
          }
          throw _makeDoNotSendEventError("".concat(beforeSendLabel, " returned `null`, will not send event."));
        }
        var session = currentScope.getSession() || isolationScope.getSession();
        if (isError && session) {
          _this5._updateSessionFromEvent(session, processedEvent);
        }
        if (isTransaction) {
          var _processedEvent$sdkPr;
          var spanCountBefore = ((_processedEvent$sdkPr = processedEvent.sdkProcessingMetadata) === null || _processedEvent$sdkPr === void 0 ? void 0 : _processedEvent$sdkPr.spanCountBeforeProcessing) || 0;
          var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
          var droppedSpanCount = spanCountBefore - spanCountAfter;
          if (droppedSpanCount > 0) {
            _this5.recordDroppedEvent('before_send', 'span', droppedSpanCount);
          }
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        var transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          var source = 'custom';
          processedEvent.transaction_info = _objectSpread(_objectSpread({}, transactionInfo), {}, {
            source: source
          });
        }
        _this5.sendEvent(processedEvent, hint);
        return processedEvent;
      }).then(null, function (reason) {
        if (_isDoNotSendEventError(reason) || _isInternalError(reason)) {
          throw reason;
        }
        _this5.captureException(reason, {
          mechanism: {
            handled: false,
            type: 'internal'
          },
          data: {
            __sentry__: true
          },
          originalException: reason
        });
        throw _makeInternalError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(reason));
      });
    }

    /**
     * Occupies the client with processing and event
     */
  }, {
    key: "_process",
    value: function _process(promise) {
      var _this6 = this;
      this._numProcessing++;
      void promise.then(function (value) {
        _this6._numProcessing--;
        return value;
      }, function (reason) {
        _this6._numProcessing--;
        return reason;
      });
    }

    /**
     * Clears outcomes on this client and returns them.
     */
  }, {
    key: "_clearOutcomes",
    value: function _clearOutcomes() {
      var outcomes = this._outcomes;
      this._outcomes = {};
      return Object.entries(outcomes).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          quantity = _ref5[1];
        var _key$split = key.split(':'),
          _key$split2 = _slicedToArray(_key$split, 2),
          reason = _key$split2[0],
          category = _key$split2[1];
        return {
          reason: reason,
          category: category,
          quantity: quantity
        };
      });
    }

    /**
     * Sends client reports as an envelope.
     */
  }, {
    key: "_flushOutcomes",
    value: function _flushOutcomes() {
      DEBUG_BUILD && debug.log('Flushing outcomes...');
      var outcomes = this._clearOutcomes();
      if (outcomes.length === 0) {
        DEBUG_BUILD && debug.log('No outcomes to send');
        return;
      }

      // This is really the only place where we want to check for a DSN and only send outcomes then
      if (!this._dsn) {
        DEBUG_BUILD && debug.log('No dsn provided, will not send outcomes');
        return;
      }
      DEBUG_BUILD && debug.log('Sending outcomes:', outcomes);
      var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));

      // sendEnvelope should not throw
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.sendEnvelope(envelope);
    }

    /**
     * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
     */
  }]);
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  var invalidValueError = "".concat(beforeSendLabel, " must return `null` or a valid event.");
  if (isThenable(beforeSendResult)) {
    return beforeSendResult.then(function (event) {
      if (!isPlainObject(event) && event !== null) {
        throw _makeInternalError(invalidValueError);
      }
      return event;
    }, function (e) {
      throw _makeInternalError("".concat(beforeSendLabel, " rejected with ").concat(e));
    });
  } else if (!isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw _makeInternalError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(client, options, event, hint) {
  var beforeSend = options.beforeSend,
    beforeSendTransaction = options.beforeSendTransaction,
    beforeSendSpan = options.beforeSendSpan,
    ignoreSpans = options.ignoreSpans;
  var processedEvent = event;
  if (isErrorEvent(processedEvent) && beforeSend) {
    return beforeSend(processedEvent, hint);
  }
  if (isTransactionEvent(processedEvent)) {
    // Avoid processing if we don't have to
    if (beforeSendSpan || ignoreSpans) {
      // 1. Process root span
      var rootSpanJson = convertTransactionEventToSpanJson(processedEvent);

      // 1.1 If the root span should be ignored, drop the whole transaction
      if (ignoreSpans !== null && ignoreSpans !== void 0 && ignoreSpans.length && shouldIgnoreSpan(rootSpanJson, ignoreSpans)) {
        // dropping the whole transaction!
        return null;
      }

      // 1.2 If a `beforeSendSpan` callback is defined, process the root span
      if (beforeSendSpan) {
        var processedRootSpanJson = beforeSendSpan(rootSpanJson);
        if (!processedRootSpanJson) {
          showSpanDropWarning();
        } else {
          // update event with processed root span values
          processedEvent = merge(event, convertSpanJsonToTransactionEvent(processedRootSpanJson));
        }
      }

      // 2. Process child spans
      if (processedEvent.spans) {
        var processedSpans = [];
        var initialSpans = processedEvent.spans;
        var _iterator3 = _createForOfIteratorHelper(initialSpans),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var span = _step3.value;
            // 2.a If the child span should be ignored, reparent it to the root span
            if (ignoreSpans !== null && ignoreSpans !== void 0 && ignoreSpans.length && shouldIgnoreSpan(span, ignoreSpans)) {
              reparentChildSpans(initialSpans, span);
              continue;
            }

            // 2.b If a `beforeSendSpan` callback is defined, process the child span
            if (beforeSendSpan) {
              var processedSpan = beforeSendSpan(span);
              if (!processedSpan) {
                showSpanDropWarning();
                processedSpans.push(span);
              } else {
                processedSpans.push(processedSpan);
              }
            } else {
              processedSpans.push(span);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var droppedSpans = processedEvent.spans.length - processedSpans.length;
        if (droppedSpans) {
          client.recordDroppedEvent('before_send', 'span', droppedSpans);
        }
        processedEvent.spans = processedSpans;
      }
    }
    if (beforeSendTransaction) {
      if (processedEvent.spans) {
        // We store the # of spans before processing in SDK metadata,
        // so we can compare it afterwards to determine how many spans were dropped
        var spanCountBefore = processedEvent.spans.length;
        processedEvent.sdkProcessingMetadata = _objectSpread(_objectSpread({}, event.sdkProcessingMetadata), {}, {
          spanCountBeforeProcessing: spanCountBefore
        });
      }
      return beforeSendTransaction(processedEvent, hint);
    }
  }
  return processedEvent;
}
function isErrorEvent(event) {
  return event.type === undefined;
}
function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/** Extract trace information from scope */
function _getTraceInfoFromScope(client, scope) {
  if (!scope) {
    return [undefined, undefined];
  }
  return withScope(scope, function () {
    var span = getActiveSpan();
    var traceContext = span ? spanToTraceContext(span) : getTraceContextFromScope(scope);
    var dynamicSamplingContext = span ? getDynamicSamplingContextFromSpan(span) : getDynamicSamplingContextFromScope(client, scope);
    return [dynamicSamplingContext, traceContext];
  });
}
export { Client, _getTraceInfoFromScope };